import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import React from 'react';
import css from './css.module.less';

const _SectionWrapper = (props) => {
  const { children, ...rest } = props;
  return (
    <SectionWrapper className={css.container} {...rest}>
      {children}
    </SectionWrapper>
  );
};
export default _SectionWrapper;
